module.exports = __webpack_public_path__ + "img/kk-back.cdd6f841.png";